import http from "./http-common";
import { isTokenExpired } from "../helpers/TokenHelper";
import { IGetVariantModal, IproductValue } from "../models/productvalue.Model";
import createHttpInstance from "./http-common";

class ModelVariantsServices {
    private serviceName = "/modelvariant";


   async GetVariantsv1(data: IGetVariantModal) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetVariants`, data).catch((err: Error) => {
            throw err?.message;
        });
    }

    async UpdateModelVarients(data: IproductValue) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/UpdateModelVarients`, data).catch((err: Error) => {
            throw err?.message;
        })
    }

}

export default new ModelVariantsServices();